import React from "react";
import Tags from "./Tags";

export default function TagDisplay({
  isShowBox = true,
  width = "75%",
  icon,
  title,
  tags,
  margin = 0,
}) {
  return (
    <div
      className={isShowBox ? "teal-box" : ""}
      style={{ width: width, margin: margin }}
    >
      <div style={{ marginBottom: 10 }}>
        <span className="smaller-text">
          {icon && (
            <img
              src={icon}
              style={{ width: 14, height: 14, marginRight: 8 }}
              alt="icon"
            />
          )}
          {title}
        </span>
      </div>
      <Tags tags={tags} />
    </div>
  );
}
